var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAvatarPlaceholder = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1844_2549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 5.47754C10.2218 5.47754 7.96774 7.66113 7.96774 10.3525C7.96774 13.0439 10.2218 15.2275 13 15.2275C15.7782 15.2275 18.0323 13.0439 18.0323 10.3525C18.0323 7.66113 15.7782 5.47754 13 5.47754ZM13 12.79C11.6109 12.79 10.4839 11.6982 10.4839 10.3525C10.4839 9.00684 11.6109 7.91504 13 7.91504C14.3891 7.91504 15.5161 9.00684 15.5161 10.3525C15.5161 11.6982 14.3891 12.79 13 12.79ZM13 0.602539C5.81855 0.602539 0 6.23926 0 13.1963C0 20.1533 5.81855 25.79 13 25.79C20.1815 25.79 26 20.1533 26 13.1963C26 6.23926 20.1815 0.602539 13 0.602539ZM13 23.3525C10.3948 23.3525 8.01492 22.4232 6.18024 20.8947C6.96129 19.7268 8.29798 18.9346 9.82863 18.8889C10.919 19.2139 11.9569 19.3764 13 19.3764C14.0431 19.3764 15.081 19.2189 16.1714 18.8889C17.702 18.9396 19.0387 19.7268 19.8198 20.8947C17.9851 22.4232 15.6052 23.3525 13 23.3525ZM21.5286 19.0818C20.2496 17.4873 18.2734 16.4463 16.0194 16.4463C15.4847 16.4463 14.6565 16.9338 13 16.9338C11.3488 16.9338 10.5153 16.4463 9.98064 16.4463C7.73185 16.4463 5.75565 17.4873 4.47137 19.0818C3.24476 17.4213 2.51613 15.39 2.51613 13.1963C2.51613 7.59512 7.21814 3.04004 13 3.04004C18.7819 3.04004 23.4839 7.59512 23.4839 13.1963C23.4839 15.39 22.7552 17.4213 21.5286 19.0818Z",
    fill: "#535F77"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1844_2549"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(0 0.196289)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAvatarPlaceholder);
export default ForwardRef;